@if (finishedLoading) {
    <div class="container-fluid pt-3">
        <ngx-masonry [options]="{ percentPosition: true, gutter: 10, horizontalOrder: false }">
            @for (c of getCategories(); track c) {
                <div ngxMasonryItem class="masonry-item">
                    <div class="card">
                        <div class="card-header">{{ 'report.categoryReportsHeader' | transloco: { category: c } }}</div>
                        <div class="list-group">
                            @for (d of getCategoryReports(c); track d) {
                                <div class="list-group-item list-group-item-action d-flex">
                                    <div
                                        class="w-100 justify-content-between"
                                        (click)="open(d)"
                                        role="button"
                                    >
                                        <h5 class="mb-1">{{ d.Name }}</h5>
                                        <p class="mb-1">{{ d.Description }}</p>
                                    </div>
                                    <i
                                        class="fas fa-download"
                                        [title]="'report.downloadTitle' | transloco"
                                        (click)="download(d)"
                                        role="button"
                                    ></i>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </ngx-masonry>
    </div>
}
